<template>
    <div id="app" class="grid-container">
        <div class="navbar">
            <Navbar></Navbar>
        </div>
        <div class="main">
            <div v-if="status == 'ok'">
                <router-view/>
            </div>
            <div class="app-load" v-else>
                <div>Preparing your tournaments!</div>
                <Loader v-bind:status="status"></Loader>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Loader from './components/Loader.vue'


export default {
    name: 'app',
    components: {
        Navbar,
        Loader
    },
    beforeMount(){
        this.$store.dispatch('checkUserStatus')
        .then(user => {
            if(user){
                this.$store.dispatch('getEverythingFromFirestore')
            }
        })
    },

    computed: {
        status(){
            return this.$store.state.status
        }
    }
}
</script>

<style>
/* Alt. color #f79c20 */

/*Background*/
html{
    background-image: url(./assets/bg.jpg);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
}

/* The grid container*/
.grid-container {
    display: grid;
    grid-template-areas:
    'navbar'
    'main';
    margin: auto;
}

.inner-grid-container {
    display: grid;
    grid-template-columns:auto 500px auto;
    grid-template-areas:
        'banner banner  banner'
        'left   middle  right';
    grid-row-gap: 25px;
}
#app {
    font-family: 'Ubuntu', sans-serif;
    height: 100%;
}


.navbar{
    grid-area: navbar;
    text-align: center;
    align-items: center;
    width: -webkit-fill-available;
}

.middle {
    grid-area: middle;
}
.banner{
    grid-area: banner;
}

.app-load{
    text-align: center;
    margin-top: 20%;
}
.app-load > div{
    margin: 20px;
    font-size: 30px;
    color: orange;
}

.buttonBigStyle {
    font-size: 20px;
    background-color: #22222280;
    border: none;
    color: orange;
    padding: 10px 15px;
    text-decoration: none;
    border-radius: 2px;
    margin: 10px;
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
}

.buttonBigStyle:hover{
    background-color: orange;
    color: #222222;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0);
}


.teamBoxAdd{
    background-color: transparent;
    border-color: orange;
    border-style: dotted;
}

.card{
    background-image: url(./assets/cardcool2.png);
    background-color: orange;
    margin-top: 10px;
    margin-bottom: 10px;
    color: orange;
    /*max-width: 496px;*/

    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
    cursor: pointer;
}

.card:hover{
    /*transform: scale(1.03);
    -webkit-transform: scale(1.03);
    -moz-transform: scale(1.03);
    -o-transform: scale(1.03);

    transition: 0.01s all ease-in-out 0s;
    -webkit-transition: 0.01s all ease-in-out 0s;
    -moz-transition: 0.01s all ease-in-out 0s;
    -o-transition: 0.01s all ease-in-out 0s;*/
}

.hover:hover{
    transform: scale(1.03);
    -webkit-transform: scale(1.03);
    -moz-transform: scale(1.03);
    -o-transform: scale(1.03);
}

.red-glow:hover{
    box-shadow: 0 0 10px 2px rgba(255, 0, 106, 0.2), 0 0 20px 4px rgba(255, 0, 0, 0.25);
}
.light-glow{
    box-shadow: 0 0 10px 2px rgba(255, 123, 0, 0.2), 0 0 20px 4px rgba(255, 115, 0, 0.25);
}
.green-glow:hover{
    box-shadow: 0 0 5px 2px rgba(0, 255, 13, 0.1), 0 0 10px 4px rgba(94, 255, 0, 0.15);
}

.shadow{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
}

.winner{
    /*border-style: solid;
    border-width: 5px;
    border-color: orange;*/
    /*box-shadow: 0 0 10px 2px rgba(255, 123, 0, 0.2), 0 0 20px 4px rgba(255, 115, 0, 0.25);*/
    box-shadow: inset 0 0 0 100px rgba(255, 166, 0, 0.493);
    color: black;
}
.loser{
}

.dragging:hover{
    transform: scale(1.03);
    -webkit-transform: scale(1.03);
    -moz-transform: scale(1.03);
    -o-transform: scale(1.03);
}

.playerName{
    font-size: 25px;
    margin: 30px;
    /*text-align: center;*/
}

.cardLogo{
    height: 100px;
    width: 100px;
    object-fit: cover;

}

input{
    height: 50px;
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    font-family: 'Ubuntu', sans-serif;
    color: orange;
    font-size: 20px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 10px;
}

input:focus{
    border: none;
    outline: none;
}

.addText{
    font-size: 23px;
    margin-top: 10px;
    color: orange;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    font-family: 'Ubuntu', sans-serif;
    color: orange;
    font-size: 20px;
}
::-moz-placeholder { /* Firefox 19+ */
    font-family: 'Ubuntu', sans-serif;
    color: orange;
    font-size: 20px;
}
:-ms-input-placeholder { /* IE 10+ */
    font-family: 'Ubuntu', sans-serif;
    color: orange;
    font-size: 20px;
}
:-moz-placeholder { /* Firefox 18- */
    font-family: 'Ubuntu', sans-serif;
    color: orange;
    font-size: 20px;
}
.fancyHeading{
    font-size: 60px;
    text-align: center;
    vertical-align: middle;
    line-height: 400px;
    font-weight: bold;
    -webkit-text-stroke: 1px orange;
    color: white;
    text-shadow: 2px 2px 5px black;
}

.loginSignup{
    display: grid;
    grid-template-areas:
    'title'
    'emailInput'
    'passwordInput'
    'button';
    text-align: center;
}
.emailInput{
    margin-top: 10px;
    margin-bottom: 10px;
}
.passwordInput{
    margin-top: 10px;
    margin-bottom: 10px;
}
.loginSignupBG{
    background-color: #333333;
    padding-left: 40px;
    padding-right: 40px;
    margin: auto;
    margin-top: 20px;
    border-radius: 8px;
}

.vertical{
    writing-mode:tb-rl;
    -webkit-transform:rotate(180deg);
    -moz-transform:rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform:rotate(180deg);
    transform: rotate(180deg);
}

@media (max-width: 600px) {
    .loginSignupBG{
        margin: 0px;
        margin-top: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .inner-grid-container{
      grid-template-columns: auto;
      grid-template-areas:
      'banner'
      'middle'
      'rigth'
      'left' ;
    }

    .fancyHeading{
        font-size: 32px;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue